// import { Field } from "formik";
import Select from "react-select";
import { useEffect, useState } from "react";
import axios from "axios";
import { url } from "../../../config";

export const PropertySelector = ({ value, onChange }) => {
  const [propertyList, setPropertyList] = useState([]);
  const propertyListFnc = async () => {
    axios
      .post(`${url}/dropdown/property-list`)
      .then((res) => {
        let newArr = res?.data?.data?.properties?.map((ele) => ({
          label: ele.title,
          value: ele.id,
        }));
        setPropertyList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  useEffect(() => {
    propertyListFnc();
  }, []);

  return (
    <div>
      <label className={`text-fs_16 capitalize text-darkText`}>
        Properties
      </label>
      <div
        className={`border-[1px] rounded-lg px-[0.2rem] py-[0.1rem] pb-[0.4rem] mt-1 w-full border-greyText `}
      >
        <Select
          name={"properties"}
          isMulti
          value={value}
          options={propertyList}
          placeholder={"please select properties"}
          onChange={(selectedOptions) => {
            var obj = selectedOptions.map((option) => option.value);
            onChange(selectedOptions);
          }}
          styles={customStyles}
          menuPlacement="top"
        />
      </div>
    </div>
  );
};

export const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    color: "#0000",
    width: "100%",
    border: "none",
    boxShadow: state.isFocused ? null : null,
  }),
  placeholder: (defaultStyles) => ({
    ...defaultStyles,
    color: "#B0B3C7",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    color: "#50BF97",
    ":hover": {
      backgroundColor: "#50BF97",
      color: "white",
    },
  }),
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected ? "white" : "black",
    backgroundColor: state.isSelected ? "#50BF97" : "white",
    ":hover": {
      backgroundColor: "#50BF97",
      color: "white",
    },
  }),
};
